import { render, staticRenderFns } from "./demandPrediction.vue?vue&type=template&id=cf9b41e8"
import script from "./demandPrediction.vue?vue&type=script&lang=js"
export * from "./demandPrediction.vue?vue&type=script&lang=js"
import style0 from "./demandPrediction.vue?vue&type=style&index=0&id=cf9b41e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports